export default {
  location: 'Local',
  person: 'Persona',
  fleet: 'Flota',
  assets: 'Activos',
  deactivatedPlace: 'Este código QR está vinculado a un local desactivado.'
}
